<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Logs de Integração</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Consulte aqui o histórico de requisições das APIs de integração
                </p>
            </div>
        </div>
        @if(_isLoading) {
        <app-loading-box></app-loading-box>
        } @else if (log) {
        <div class="details-header">
            <div class="row">
                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">URI</span>
                    <span class="detail-value">{{ log.verboHttp }} {{ log.descricaoUri }}</span>
                </div>

                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">IP</span>
                    <span class="detail-value">{{ log.ipRequest }}</span>
                </div>

                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">Chave de Integração</span>
                    <span class="detail-value">{{ log.chaveAcessoNome }}</span>
                </div>

                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">Data da requisição</span>
                    <span class="detail-value">{{ log.datetimeInicioRequest | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                </div>

                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">Status</span>
                    <span class="detail-value">{{ log.tipoLog }}</span>
                </div>

                @if(log.idPedido) {
                <div class="col-12 col-md-4 detail-item">
                    <span class="detail-label">ID Pedido</span>
                    <span class="detail-value">{{ log.idPedido }}</span>
                </div>
                }
            </div>
        </div>

        <h2 class="subtitle-default">Conteúdo da requisição</h2>
        <div class="json-viewer">
            <button mat-icon-button class="copy-button" (click)="copiarJson(requestJsonFormatado)"
                matTooltip="Copiar JSON">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre><code>{{ requestJsonFormatado }}</code></pre>
        </div>

        <h2 class="subtitle-default">Resposta da requisição</h2>
        <div class="json-viewer">
            <button mat-icon-button class="copy-button" (click)="copiarJson(responseJsonFormatado)"
                matTooltip="Copiar JSON">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre><code>{{ responseJsonFormatado }}</code></pre>
        </div>

        <div class="action-buttons">
            <button type="button" mat-stroked-button class="btn-secondary" (click)="voltar()">Voltar</button>
        </div>
        } @else {
        <p class="text-center mt-5">Log não encontrado.</p>
        }
    </div>
</div>